import { styled } from '@mui/material';
import UPButton from 'components/button';

export const ViewReportsButton = styled(UPButton)({
  width: '200px',
  height: '40px',
  fontSize: '14px',
  whiteSpace: 'nowrap',
});
